import * as React from 'react';

import { Button } from '@coursera/cds-core';

import { ADMISSION_DETAILS_BUTTON } from 'bundles/degree-home/components/v3-dpm/constants/trackingNameConstants';
import type { TrackingProps } from 'bundles/page/components/TrackedLink2';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/degree-home';

type Props = {
  href: string;
};
const AdmissionDetailsButton: React.VFC<Props> = ({ href }) => {
  return (
    <Button
      trackingName={ADMISSION_DETAILS_BUTTON}
      withVisibilityTracking
      component={(props: TrackingProps) => (
        <TrackedLink2 {...props} target="_blank" rel="noopener noreferrer" href={href} />
      )}
      size="small"
      variant="ghost"
      aria-label={_t('Admission details')}
    >
      {_t('Admission details')}
    </Button>
  );
};

export default AdmissionDetailsButton;
